import vtkInteractorStyleImage from './InteractorStyleImage';
import vtkInteractorStyleManipulator from './InteractorStyleManipulator';
import vtkInteractorStyleTrackballCamera from './InteractorStyleTrackballCamera';
import vtkInteractorStyleMPRSlice from './InteractorStyleMPRSlice';

export default {
  vtkInteractorStyleImage,
  vtkInteractorStyleManipulator,
  vtkInteractorStyleTrackballCamera,
  vtkInteractorStyleMPRSlice,
};
